import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallbackComponent } from "./Common/ErrorComponents";
import { AuthProvider, AuthContext } from "./Auth/Auth";
import SignInPage from "./Auth/SignInPage";
import ReminderPage from "./Auth/ReminderPage";
import PasswordPage from "./Auth/PasswordPage";
import PasswordEndPage from "./Auth/PasswordEndPage";
import CompletedPage from "./Auth/CompletedPage";
import { MainHeader } from "./Common/MainHeader";
import { SideMenu } from "./Common/SideMenu";
import PreparatoryStudentList from "./FU-25/PreparatoryStudentList";
import { Layout, ConfigProvider, Result } from "antd";
import jaJP from "antd/lib/locale/ja_JP";
import { ValidateMessages } from "./Common/ValidateMessages";
// import { CookiesProvider } from "react-cookie";
import ScoringList from "./FU-48/ScoringList";
import UserList from "./FU-12/UserList";
import UserRegister from "./FU-11/UserRegister";
import ResetPassword from "./FU-04/ResetPassword";
import ExaminationList from "./FM-03/ExaminationList";
import ExaminationRegister from "./FM-02/ExaminationRegister";
import ChgPasswordPage from "./FU-03/ChgPasswordPage";
import ApplicantPage from "./FU-21/ApplicantPage";
import { QuestionList } from "./FU-63/QuestionList";
import React from "react";
import { DocumentRegistPage } from "./FU-26/DocumentRegistPage";
import QuestionRegist from "./FU-64/QuestionRegist";
import { CompleteChangePasswordPage } from "./FU-03/CompleteChangePasswordPage";
import { DocumentRegistResultPage } from "./FU-26/DocumentRegistResultPage";
import { ProgressPage } from "./FU-41/ProgressPage";
import RubricList from "./FU-61/RubricList";
import RubricRegister from "./FU-62/RubricRegister";
import { HomePage } from "./Common/HomePage";
import { AllocationPage } from "./FU-42/AllocationPage";
import ScoringResultListPage from "./FU-46/ScoringResultListPage";
import { PassFailureJustmentPage } from "./FU-51/PassFailureJustmentPage";
import { ScoringPage } from "./FU-45/ScoringPage";
import CreateInterviewGroup from "./FU-44/CreateInterviewGroup";
import { ScoringConfirmPage } from "./FU-47/ScoringConfirmPage";
import { ScoringResultViewPage } from "./FU-30/ScoringResultViewPage";
import { ScoringUpdatePage } from "./FU-49/ScoringUpdatePage";
import { ScorePassfailurePage } from "./FU-22/ScorePassfailurePage";
import moment from "moment";

const { Header } = Layout;

ConfigProvider.config({
  theme: {
    primaryColor: "#3fb0ac",
  },
});

// function Bomb(): any {
//   throw new Error("💥 KABOOM 💥");
// }

function App() {
  const [contentMarginLeft, setContentMarginLeft] = React.useState<number>(200);
  moment.updateLocale("ja", {
    monthsShort: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月",
    ],
    weekdaysMin: ["日", "月", "火", "水", "木", "金", "土"],
  });
  return (
    // <CookiesProvider>
    <ConfigProvider
      form={{ validateMessages: ValidateMessages }}
      locale={jaJP}
      componentSize={"small"}
      space={{ size: "small" }}
    >
      <AuthProvider>
        <AuthContext.Consumer>
          {({ isSystemOperating, loading, isAuthenticated, user }) =>
            !loading &&
            (isSystemOperating ? (
              isAuthenticated ? (
                <BrowserRouter>
                  <Layout style={{ minHeight: "100vh" }}>
                    <MainHeader />
                    <Layout>
                      <SideMenu
                        onMenuLayoutChange={(collapsed) => {
                          if (collapsed) {
                            setContentMarginLeft(80);
                          } else {
                            setContentMarginLeft(200);
                          }
                        }}
                      />
                      <Layout
                        style={{
                          overflow: "auto",
                          marginTop: 45,
                          marginLeft: contentMarginLeft,
                        }}
                      >
                        <ErrorBoundary
                          FallbackComponent={ErrorFallbackComponent}
                          onError={(error, errorInfo) => {
                            console.log(error, errorInfo);
                            // errorService.log({ error, errorInfo })
                          }}
                          onReset={() => {
                            window.location.replace(window.location.origin);
                          }}
                        >
                          {user.passwordInitializationFlag === "1" ? (
                            <Routes>
                              {/* <Route
                                path="Bomb"
                                element={
                                  <div>
                                    <Bomb />
                                  </div>
                                }
                              /> */}
                              <Route
                                path="PreparatoryStudentList"
                                element={<PreparatoryStudentList />}
                              />
                              <Route
                                path="ScoringList"
                                element={<ScoringList />}
                              />
                              <Route path="UserList" element={<UserList />} />
                              <Route
                                path="UserRegister/:userId"
                                element={<UserRegister />}
                              />
                              <Route
                                path="ResetPw/:userId"
                                element={<ResetPassword />}
                              />
                              <Route
                                path="UserRegister"
                                element={<UserRegister />}
                              />
                              <Route
                                path="ExaminationList"
                                element={<ExaminationList />}
                              />
                              <Route
                                path="ExaminationRegister/:examinationId"
                                element={<ExaminationRegister />}
                              />
                              <Route
                                path="ExaminationRegister"
                                element={<ExaminationRegister />}
                              />
                              <Route
                                path="ChgPasswordPage"
                                element={<ChgPasswordPage />}
                              />
                              <Route
                                path="CompleteChangePassword"
                                element={<CompleteChangePasswordPage />}
                              />
                              <Route
                                path="ApplicantPage"
                                element={<ApplicantPage />}
                              />
                              <Route
                                path="QuestionList"
                                element={<QuestionList />}
                              />
                              <Route
                                path="QuestionRegist/:questionId"
                                element={<QuestionRegist />}
                              />
                              <Route
                                path="QuestionRegist"
                                element={<QuestionRegist />}
                              />
                              <Route
                                path="DocumentRegist"
                                element={<DocumentRegistPage />}
                              />
                              <Route
                                path="DocumentRegistResult"
                                element={<DocumentRegistResultPage />}
                              />
                              <Route
                                path="Progress"
                                element={<ProgressPage />}
                              />
                              <Route
                                path="RubricList"
                                element={<RubricList />}
                              />
                              <Route
                                path="RubricRegister/:rubricId"
                                element={<RubricRegister />}
                              />
                              <Route
                                path="RubricRegister"
                                element={<RubricRegister />}
                              />
                              <Route
                                path="ScoreResult"
                                element={<ScorePassfailurePage />}
                              />
                              <Route
                                path="Allocation"
                                element={<AllocationPage />}
                              />
                              <Route
                                path="ScoringResultList"
                                element={<ScoringResultListPage />}
                              />
                              <Route
                                path="PassFailureJustment"
                                element={<PassFailureJustmentPage />}
                              />
                              <Route
                                path="Scoring/:examSubjectId/:objectId"
                                element={<ScoringPage />}
                              />
                              <Route
                                path="CreateInterviewGroup"
                                element={<CreateInterviewGroup />}
                              />
                              <Route
                                path="ScoringConfirm/:examSubjectId/:objectId"
                                element={<ScoringConfirmPage />}
                              />
                              <Route
                                path="ScoringResultView/:examSubjectId/:objectId"
                                element={<ScoringResultViewPage />}
                              />
                              <Route
                                path="ScoringUpdate/:examSubjectId/:objectId"
                                element={<ScoringUpdatePage />}
                              />
                              <Route path="*" element={<HomePage />} />
                            </Routes>
                          ) : (
                            <Routes>
                              <Route
                                path="*"
                                element={<ChgPasswordPage></ChgPasswordPage>}
                              />
                            </Routes>
                          )}
                        </ErrorBoundary>
                      </Layout>
                    </Layout>
                    {/* <Footer>Footer</Footer> */}
                  </Layout>
                </BrowserRouter>
              ) : (
                <BrowserRouter>
                  <Layout style={{ minHeight: "100vh" }}>
                    <Header></Header>
                    <Routes>
                      <Route path="Login" element={<SignInPage />} />
                      <Route path="Reminder" element={<ReminderPage />} />
                      <Route path="Password/:Id" element={<PasswordPage />} />
                      <Route path="PasswordEnd" element={<PasswordEndPage />} />
                      <Route path="Completed/*" element={<CompletedPage />} />
                      <Route path="*" element={<SignInPage />} />
                    </Routes>
                    {/* <Footer></Footer> */}
                  </Layout>
                </BrowserRouter>
              )
            ) : (
              <Result
                status="500"
                subTitle="今の時間は、システムをご利用頂けません"
              />
            ))
          }
        </AuthContext.Consumer>
      </AuthProvider>
    </ConfigProvider>
    // </CookiesProvider>
  );
}

export default App;
